/**
 * specs/product-kernel/dashboard-ukrainian-localization.md
 */

export type Locale = 'en' | 'uk';

/** `Intl.*` locale tag for each supported `Locale` — used for number/date formatting. */
export const INTL_LOCALE: Record<Locale, string> = {
  en: 'en-US',
  uk: 'uk-UA',
};
